import { useMemo } from "react";

import { useCountriesQuery } from "../../queries/countries";
import { IUseCountryOptionsResult } from "../input/CountrySelect";

const EMPTY_ARRAY: [] = [];
export function usePassportCountryOptions(): IUseCountryOptionsResult {
    const { data, isLoading } = useCountriesQuery();
    return useMemo(
        () => ({
            options:
                data?.passportCountries.map(({ countryCode, name }) => ({ label: name, value: countryCode })) ??
                EMPTY_ARRAY,
            isLoading,
        }),
        [data?.passportCountries, isLoading],
    );
}
